export enum WwwRouteSlug {
  HOME = '',
  LOGIN = 'login',
  ACTIVATE_ACCOUNT = 'activate-account',
  RESET_PASSWORD = 'reset-password',
  CHANGE_PASSWORD = 'change-password',
  CONTACT = 'contact',

  ACCOUNT = 'account',
  MY_DATA = 'my-data',
  PRO_EDUCATION = 'pro-education',
  PRO_EXPERIENCE = 'pro-experience',
  PRO_SUPPORT = 'pro-support',
  ORDERS = 'orders',
  ABOUT_US = 'about-us',
  BRAND = 'brand',

  // Cities
  MADRID = 'madryt',
  SINGAPUR = 'singapur',

  // Documents
  PRIVACY_POLICY = 'privacy-policy',
  COOKIES_POLICY = 'cookies-policy',

  //Event Ticket
  EVENT_TICKET = 'zapisz',

  NOT_FOUND_PAGE = '404',
}
